module.exports = __webpack_public_path__ + "img/4.6a8ae89d.png";